import { render, staticRenderFns } from "./try_notice.vue?vue&type=template&id=36bef6c0&scoped=true&"
import script from "./try_notice.vue?vue&type=script&lang=js&"
export * from "./try_notice.vue?vue&type=script&lang=js&"
import style0 from "./try_notice.vue?vue&type=style&index=0&id=36bef6c0&scoped=true&lang=less&"
import style1 from "./try_notice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bef6c0",
  null
  
)

export default component.exports